export const PRIVACY_URL = 'https://www.kudos.com/privacy-policy'
export const TERMS_OF_SERVICE_URL = 'https://www.kudos.com/terms-of-service?en'
